import React from 'react';
import styled from '@emotion/styled';
import { SunSpinner } from '@sunrun/component-library';

const StyledLoader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 26, 60, 0.9);
  position: abolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`;

const AbsoluteLoading = () => (
  <StyledLoader>
    <SunSpinner sunSize="5" raySize="0.75" />
  </StyledLoader>
);

export default AbsoluteLoading;
